import React from 'react';
import { TitleText, BodyText, BodyTextSmall } from './common';
import { ContinueWithAppleButton } from '../components/ContinueWithAppleButton';
import { ContinueWithEmailButton } from '../components/ContinueWithEmailButton';
import { ContinueWithFacebookButton } from '../components/ContinueWithFacebookButton';
import { ContinueWithGoogleButton } from '../components/ContinueWithGoogleButton';
import { routes } from 'js/utils';
import { Options as ClickTrackingOptions } from 'js/utils/trackClick';
import styled from 'astroturf/react'
import { VerticalSpacer } from '../components/VerticalSpacer';
import { ModalError } from '../components/ModalError';
import { ButtonsPageConfigurableText, RegistrationParams } from '../types';
import _ButtonStyleContext from "ButtonsPage-ButtonStyleContext.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/login_modal/pages/ButtonsPage.tsx?styleId=ButtonStyleContext";
import _SharedButtonStyles from "ButtonsPage-SharedButtonStyles.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/login_modal/pages/ButtonsPage.tsx?styleId=SharedButtonStyles";


type Props = {
  onAttempt?: () => void;
  onAuthorized?: () => void;
  onSuccess?: (redirect?: string) => void;
  onError: (error?: { errorMessage?: string; errorCodes?: string[] }) => void;
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  errorMessage?: string;
  onEmailButtonClick: () => void;
  show: boolean;
  clickTrackingContext?: Partial<ClickTrackingOptions>;
  text: ButtonsPageConfigurableText;
  registrationParams: RegistrationParams;
};

const ButtonStyleContext = /*#__PURE__*/styled("div", null, {
  displayName: "ButtonStyleContext",
  styles: _ButtonStyleContext
});

const SharedButtonStyles = _SharedButtonStyles;

export const ButtonsPage: React.FC<Props> = (props) => {
  const {
    onAttempt,
    onSuccess,
    onError,
    loading,
    setLoading,
    errorMessage,
    onEmailButtonClick,
    show,
    clickTrackingContext,
    text,
    registrationParams,
  } = props;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const userInChina = (window as any).userInChina === 'true';

  return (
    <ButtonStyleContext show={show}>
      <TitleText>{text.header}</TitleText>
      <BodyText>{text.subheader}</BodyText>
      <ModalError errorMessage={errorMessage} show={Boolean(errorMessage)} />
      <VerticalSpacer height={32} />
      {!userInChina && (
        <ContinueWithGoogleButton
          onAttempt={onAttempt}
          onError={onError}
          onSuccess={onSuccess}
          disabled={loading}
          className={SharedButtonStyles.margins}
          setLoading={setLoading}
          clickTrackingContext={clickTrackingContext}
          buttonText={text.googleButton}
          registrationParams={registrationParams}
        />
      )}
      <ContinueWithAppleButton
        onAttempt={onAttempt}
        onError={onError}
        onSuccess={onSuccess}
        disabled={loading}
        className={SharedButtonStyles.margins}
        setLoading={setLoading}
        clickTrackingContext={clickTrackingContext}
        buttonText={text.appleButton}
        registrationParams={registrationParams}
      />
      {!userInChina && (
        <ContinueWithFacebookButton
          onAttempt={onAttempt}
          onError={onError}
          onSuccess={onSuccess}
          disabled={loading}
          className={SharedButtonStyles.margins}
          setLoading={setLoading}
          clickTrackingContext={clickTrackingContext}
          buttonText={text.facebookButton}
          registrationParams={registrationParams}
        />
      )}
      <ContinueWithEmailButton
        onClick={onEmailButtonClick}
        disabled={loading}
        className={SharedButtonStyles.margins}
        buttonText={text.emailButton}
      />
      <VerticalSpacer height={40} />
      <BodyTextSmall>
        By continuing, you agree to our{' '}
        <a href={routes.terms_path()}>Terms of Use</a>
      </BodyTextSmall>
    </ButtonStyleContext>
  );
};
